import { render, staticRenderFns } from "./Nbsy.vue?vue&type=template&id=2be4e13a&scoped=true&"
import script from "./Nbsy.vue?vue&type=script&lang=js&"
export * from "./Nbsy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4e13a",
  null
  
)

export default component.exports